import styled from 'styled-components';

export const StyledOverlay = styled.div`
    position: ${(props: any) => (props.preview ? 'absolute' : 'fixed')};
    width: 100%;
    height: 100%;
    visibility: ${(props: any) => (props.visible ? 'visible' : 'hidden')};
    display: flex;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    z-index: ${(props: any) => props.zIndex};
    background: ${(props: any) =>
        props.showOverlay
            ? `rgba(0, 0,0, ${props.overlayPercentage}%)`
            : 'transparent'};
` as any;
